// Contrato consumido do endpoint PUT /cadastro/prestador/situacao e GET /cadastro/prestador/situacao/inadimplente (Task 2).

/**
 * Grupos reativados quando a situação volta para 1 (ativo) a partir de {5, 9, 10}.
 * Espelha o CheckListBox do legado (TFrmCancelamento).
 */
export interface PrestadorReativacaoGruposRequest {
    comissaoEtica: boolean;
    corpoClinico: boolean;
    diretoria: boolean;
    corpoSocietario: boolean;
}

export interface PrestadorAlterarSituacaoRequest {
    id: number;
    uf: string;
    /** id da nova situação (PJ_REF_SITUACAO). */
    novaSituacao: number;
    /** yyyy-MM-dd, obrigatório e menor ou igual a hoje. */
    dtSituacao: string;
    /** Usado apenas na reativação (novaSituacao = 1). */
    grupos?: PrestadorReativacaoGruposRequest | null;
    /** Confirmação de inadimplência (situação 6/7). Default false. */
    confirmaInadimplencia?: boolean;
}

export interface PrestadorAlterarSituacaoResponse {
    id: number;
    uf: string;
    idSituacao: number;
    dtSituacao: string;
    dtInscricao?: string | null;
}

export interface PrestadorInadimplenteResponse {
    inadimplente: boolean;
    /** Mensagem de confirmação retornada pela API; null quando inadimplente = false. */
    mensagem?: string | null;
}

/** Título estável (CfmErrorDto.title) do 409 que sinaliza confirmação de inadimplência. */
export const TITULO_INADIMPLENCIA_CONFIRMAR = 'INADIMPLENCIA_CONFIRMAR';

/** Períodos válidos da prorrogação de prazo (ComboBox do legado UntPrazoProrrogacao.pas). Default: 120. */
export const PERIODOS_PRORROGACAO = [30, 60, 90, 120] as const;

/** Contrato consumido do endpoint PUT /cadastro/prestador/prorrogacao (Task 4). */
export interface PrestadorProrrogacaoRequest {
    id: number;
    uf: string;
    /** 30, 60, 90 ou 120 dias. */
    periodo: number;
}

export interface PrestadorProrrogacaoResponse {
    id: number;
    uf: string;
    periodo: number;
    dtSituacao: string;
    dtValidadeCertificado: string;
}
